<template>
    <section class="section-title thumb-container sitecolor-content" :class="sectionClass" :style='"background-image: url(" + footer.bg4_url + ")"'>
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <h1 style="text-transform: uppercase;">{{ title }}</h1>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            title: String,
            sectionClass: String,
        },
        data() {
            return {
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            }
        },
    }
</script>

<style>

</style>
